export default __webpack_public_path__ + "static-bigflip/media/identity.4a3a72e7.png";